/* eslint-disable no-console */
import React from 'react';
import formatDate from 'date-fns/format';
import getStoreSlots from '../api/getStoreSlots';
import { FreeSlot } from '../types/FreeSlot';

export type SlotsByDate = Record<string, FreeSlot[]>;

const reduceThis = (slots: FreeSlot[]) =>
  slots
    .sort((a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime())
    .reduce<SlotsByDate>((acc, slot) => {
      const date = formatDate(new Date(slot.startDateTime), 'yyyy-MM-dd');
      acc[date] = acc[date] || [];
      acc[date].push(slot);
      return acc;
    }, {});

const useStoreSlots = (
  appointmentTypeId: string | undefined,
  shopNumber: string | undefined,
  limit: number,
): [SlotsByDate | null, boolean] => {
  const [storeSlotResponse, setStoreSlots] = React.useState<SlotsByDate | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (appointmentTypeId && shopNumber) {
      setIsLoading(true);
      const { cancel } = getStoreSlots({ appointmentTypeId, limit, shopNumber })
        .then((res) => {
          setStoreSlots(res.success ? reduceThis(res.payload.slots) : null);
        })
        .catch(() => {
          setStoreSlots(null);
        })
        .finally(() => setIsLoading(false));
      return cancel;
    } else {
      setStoreSlots(null);
    }
  }, [appointmentTypeId, shopNumber, limit]);

  return [storeSlotResponse, isLoading];
};

export default useStoreSlots;
